/**
 * 邀请码（regcode）统一处理工具
 * 优先从 URL 中获取，如果没有则从 localStorage 中获取
 * 这样即使用户通过带邀请码的链接进入后被重定向到登录页（URL 中 regcode 丢失），
 * 也能从 localStorage 中还原。
 */

const STORAGE_KEY = 'invite_regcode'

/**
 * 从 URL / Route 中获取 regcode
 */
export function getRegcodeFromUrl (route = null) {
  try {
    const routeCode = route?.query?.regcode || ''
    const urlCode = typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('regcode') || ''
      : ''
    const code = routeCode || urlCode
    return code && code.trim() ? code.trim() : ''
  } catch (e) {
    return ''
  }
}

/**
 * 从 localStorage 中获取 regcode
 */
export function getRegcodeFromStorage () {
  try {
    return localStorage.getItem(STORAGE_KEY) || ''
  } catch (e) {
    return ''
  }
}

/**
 * 将 regcode 持久化到 localStorage
 */
export function saveRegcodeToStorage (code) {
  try {
    if (code && code.trim()) {
      localStorage.setItem(STORAGE_KEY, code.trim())
    }
  } catch (e) {
    // ignore
  }
}

/**
 * 获取 regcode（统一入口）
 * 优先 URL → 其次 localStorage
 */
export function getRegcode (route = null) {
  return getRegcodeFromUrl(route) || getRegcodeFromStorage()
}

/**
 * 检测 URL 中是否有 regcode，有则持久化到 localStorage（供路由守卫调用）
 */
export function checkAndStoreRegcode (route = null) {
  const code = getRegcodeFromUrl(route)
  if (code) {
    saveRegcodeToStorage(code)
  }
}

/**
 * 登录成功后清除 localStorage 中的 regcode
 * 避免同一浏览器的后续用户误用前一个用户的邀请码
 */
export function clearRegcodeFromStorage () {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}
